import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({ type = 'grid', count = 4 }) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'banner':
        return (
          <div className="skeleton-banner square">
            <div className="skeleton-banner-content">
              <div className="skeleton-title square"></div>
              <div className="skeleton-text square"></div>
              <div className="skeleton-text-short square"></div>
              <div className="skeleton-button-row">
                <div className="skeleton-button square"></div>
              </div>
            </div>

          </div>
        );
      case 'header':
        return (
          <div className="skeleton-section-header">
            <div className="skeleton-header-title square"></div>
            <div className="skeleton-header-link square"></div>
          </div>
        );
      case 'portrait':
        return (
          <div className="skeleton-grid-container portrait">
            {[...Array(count)].map((_, i) => (
              <div key={i} className="skeleton-card">
                <div className="skeleton-image square portrait-ratio"></div>
                <div className="skeleton-info">
                  <div className="skeleton-title-sm square"></div>
                </div>
              </div>
            ))}
          </div>
        );
      case 'circle':
        return (
          <div className="skeleton-grid-container circle">
            {[...Array(count)].map((_, i) => (
              <div key={i} className="skeleton-card circle-card">
                <div className="skeleton-image square circle-ratio"></div>
                <div className="skeleton-title-xs square center-margin"></div>
              </div>
            ))}
          </div>
        );
      case 'grid':
      case 'landscape':
        return (
          <div className="skeleton-grid-container">
            {[...Array(count)].map((_, i) => (
              <div key={i} className="skeleton-card">
                <div className="skeleton-image square landscape-ratio"></div>
                <div className="skeleton-info">
                  <div className="skeleton-title-sm square"></div>
                  <div className="skeleton-text-sm square"></div>
                </div>
              </div>
            ))}
          </div>
        );
      case 'home':
        return (
          <div className="bg-dark min-vh-100 overflow-hidden">
            <div className="skeleton-banner square">
              <div className="skeleton-banner-content">
                <div className="skeleton-title square"></div>
                <div className="skeleton-text square"></div>
                <div className="skeleton-text-short square"></div>
                <div className="skeleton-button-row">
                  <div className="skeleton-button square"></div>
                </div>
              </div>
            </div>

            <div className="skeleton-section-header">
              <div className="skeleton-header-title square"></div>
              <div className="skeleton-header-link square"></div>
            </div>
            <div className="skeleton-grid-container portrait">
              {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card"><div className="skeleton-image square portrait-ratio"></div></div>)}
            </div>

            <div className="skeleton-section-header">
              <div className="skeleton-header-title square"></div>
              <div className="skeleton-header-link square"></div>
            </div>
            <div className="skeleton-grid-container landscape">
              {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card"><div className="skeleton-image square landscape-ratio"></div></div>)}
            </div>

            {/* <div className="skeleton-section-header">
              <div className="skeleton-header-title square"></div>
              <div className="skeleton-header-link square"></div>
            </div> */}
            {/* <div className="skeleton-grid-container circle">
               {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card circle-card"><div className="skeleton-image square circle-ratio"></div></div>)}
            </div> */}
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="skeleton-wrapper">{renderSkeleton()}</div>;
};

export default SkeletonLoader;
